import jQuery from 'jquery';

jQuery(function ($) {
    $('document').ready(function() {

        if($('body').hasClass('single-post')){
            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'viewed_post',
                'post_name': $('.card-post-content__title').text(),
                'post_category': $('.hero-single__title').text(),
                'post_author': $('.single-post__author a').text().replace('Por:', '')
            });
        }

        $('body').on('click', '.entry-title a, .more-link, .entry-featured-image-url', function(e) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'select_post',
                'post_name': $(this).parents('article').find('.entry-title a').text(),
                'post_category': $(this).parents('article').find('.post-meta .author a').text(),
                'post_author': $(this).parents('article').find('.post-meta [rel="tag"]').text()
            });
        });

        $('body').on('click', '.card-post .card-post__title a h3, .card-post .card-post__excerpt a p, .card-post .card-post__link a, .card-post .card-post__info a .card-post__image img', function(e) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'select_post',
                'post_name': $(this).parents('.card-post').find('.card-post__title a h3').text(),
                'post_category': $(this).parents('.card-post').find('.card-post__categories a').text(),
                'post_author': $(this).parents('.card-post').find('p.card-post__author').text()
            });
        });

        if($('body').hasClass('single-post')){
            var sw_75 = true;
            var timer = null;
            $(window).scroll(function (event) {
                if (document.documentElement.scrollTop + window.innerHeight > $('.end-post').position().top * 0.75 && sw_75 && timer == null) {
                    if (sw_75 == 'read') return;
                    timer = setTimeout(function(){ sw_75 = false; }, 10000);
                }
                if (sw_75) return;
                if (sw_75 == 'read') return;
                sw_75 = 'read';
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'read_post',
                    'post_name': $('.card-post-content__title').text(),
                    'post_category': $('.hero-single__title').text(),
                    'post_author': $('.single-post__author a').text().replace('Por:', '')
                });
            });
        }

    });
});
